<template>
    <div class="dialog-wrapper" v-if="dialogData">
        <div class="dialog-inner">
            <div class="dialog-header" v-if="dialogData.title">
                <h4 class="title">
                    {{dialogData.title}}
                </h4>
            </div>
            <div class="dialog-body" v-if="dialogData.message">
                <span>
                    {{dialogData.message}}
                </span>
            </div>
            <div class="dialog-footer" v-if="dialogData.btns && dialogData.btns.length">
                <button v-for="(item, index) in dialogData.btns" :key="index" :class="item.className" :data-link="item.link" @click="btnClick">{{item.text}}</button>
            </div>
        </div>        
    </div>
</template>

<script>

import COVER from '@/utils/COVER'
import COVERAPP from '../utils/COVERAPP'

export default {
    data() {
        return {

        }
    },
    props: ['dialogData'],
    mounted() {
        
    },
    methods: {
        btnClick(e) {
            let _this = this
            if(e.target.className == 'login-btn') {
                if(COVERAPP.Attribute.isApp()) {
                    COVERAPP.Method.OpenLogin({
                        callback (ret) {
                            let userinfo = JSON.parse(ret)
                            if (!COVER.isEmpty(userinfo.user_id)) {
                                _this.$emit('loginEvent')
                            }
                        }
                    })
                } else {
                    this.$emit('loginEvent')
                }
            } else if (e.target.className == 'link-btn') {
                let link = e.target.getAttribute('data-link') || '/'
                this.$router.push(link)
            }
            this.dialogData = null
        }
    }
}
</script>

<style lang="less">
    .dialog-wrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0,0,0,0.2);
        z-index: 2;
    }
    .dialog-inner {
        position: absolute;
        width: 7rem;
        background-color: #fff;
        border-radius: 0.1rem;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        padding: 0.3rem 0;
    }
    .dialog-header {       
        padding: 0 0.3rem 0.2rem;
        line-height: 1.5;
        h4 {
            font-size: .6rem;
            font-weight: normal;
        }
    }
    .dialog-body {
        font-size: 0.4rem;
        line-height: 1.3;
        padding: 0 0.3rem 0.3rem;
    }
    .dialog-footer {
        border-top: 1px solid #aaa;
        padding: 0.3rem 0.3rem 0;
        text-align: center;
        button {
            border: none;
            outline: none;
            appearance: none;
            font-size: 0.36rem;
            color: #fff;
            display: inline-block;
            margin: 0 0.15rem;
            background-color: #000;
            padding: 0 0.3rem 0 0.4rem;
            line-height: .8rem;
            letter-spacing: 0.1rem;
            border-radius: 0.1rem;
        }
        .close-btn {
            background-color: #aaa;
        }
    }
</style>
